import React from 'react';
import './NetworkEngineering.css'

class NetworkEngineeering extends React.Component {
  render() {
    return (
        <>
        <div className="section home wf-section net-en">
    <div className="flex-container flex-on-tablet w-container">
      <div className="text-content light narrow">
       <h1 className="first-title white">Upcoming Network Engineering Boot Camp</h1>
     </div>

     <div className=" non-hide">
      <div className="container" id="request">
        

        </div>
      </div>
    </div>
  </div>
   


<div className="page-wrap">
  <div className="section wf-section">
    <div className="course-columns">
      <div className="sticky-column">
        <div className="nav-holder"><a href="#introduction" className="course-nav-button w-inline-block t-content">
          <div>Program Schedule</div>
          </a><a href="#program" className="course-nav-button w-inline-block t-content">
          <div>Program Outline</div>
          </a><a href="#requirements" className="course-nav-button w-inline-block t-content">
          <div>Requirements</div>
         
          </a></div>
        <a href="/apply-data-analytics" className="button full-width top-padding w-button c-buuton">APPLY NOW</a>
      </div>
      

      <div className="course-content">
        <div id="introduction" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Program Highlights</h2>
            <ul>
                 <li><span class="semi-bold offset-padding">Course Curriculum :</span> <span class="bold">CCNA Preparation</span></li>

                <li><span className="semi-bold offset-padding">Duration :</span><span className="bold">10 Days</span></li>
                <li><span className="semi-bold offset-padding">Format :</span><span className="bold"> (Online/ In- person) </span></li>
                <li><span className="semi-bold offset-padding">Center :</span> <span className="bold"> Tema Mataheko/ Tema C11</span> </li>
            </ul>
          </div>
        </div>
        <div id="introduction" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Program Schedule</h2>
			<p className="paragraph-2">
        This is an 8h of intense training scheduled as follows:
        <li>8am - 10am : Session 1</li>
        <li>10am - 10:30am : Coffee break</li>
        <li>10:30am - 12:30pm : Session 2</li>
        <li>12:30pm - 1:30pm : Lunch break</li>
        <li>1:30pm - 3:30pm : Session 3</li>
        <li>3:30pm - 4pm : Snack break</li>
        <li>4pm - 6pm : Session 4 (end of the day)</li>
      </p>
			<p className="paragraph-2"> 
      Course Starts from Semptember 18th 2023 to October 2nd 2023
      </p>
	
            
			</div>
        </div>
      
        <div id="program" className="group">
          <div className="text-content centered">
            <h2 className="second-title">Program Outline</h2>
            <h2 className="second-title">Day ( 1 )</h2>
            <h2 className="second-title">NETWORK FUNDAMENTALS</h2>
            <p className="paragraph">
				<ul>
					<li className="">Concepts</li>
					<li className="">Components</li>
					<li className="">OSI model</li>
					<li className="">Architectures, Types (LAN, WAN, Metro...) and Topologies</li>
				</ul>
			</p>
      <h2 className="second-title">Day ( 2 )</h2>
      <h2 className="second-title">NETWORK FUNDAMENTALS</h2>
      <ul>
					<li className="">Layer 1 : interfaces, wiring, wireless</li>
					<li className="">Virtualization Concepts : Server virtualization, Containers, Cloud, VRF, VLAN</li>
				</ul>
        <h2 className="second-title">Hands-on : make Ethernet cables</h2>
        <h2 className="second-title">Network Access : Layer 2 connectivity</h2>
        <ul>
          <li className=''>Access port (Data / Voice)</li>
          <li className=''>CAM Table</li>
          <li className=''>Trunk port</li>
          <li className=''>LLDP / EtherChannel (LACP, PAgP)</li>
          <li className=''>VLAN & IVR</li>
        </ul>
        <h2 className="second-title">Day ( 3 )</h2>
        <h2 className="second-title">NETWORK ACCESS</h2>
        <ul>
          <li className=''>Spanning-Tree</li>
          <li className=''>Wireless Architecture and components</li>
          <li className=''>Management tools (Radius/TACACS, SSH, Telnet, HTTP, HTTPS)</li>
        </ul>
        <h2 className='second-title'>Hand-on : Configure switched network</h2>
        <h2 className="second-title">Day ( 4 )</h2>
        <h2 className="second-title">ADDRESSING</h2>
        <ul>
          <li className=''>Layer 2 addressing : MAC</li>
          <li className=''>Layer 3 addressing : <ul><li>IPv6</li><li>IPv4</li></ul></li>
          <li className=''>Layer 3 connectivity <ul><li>Static routing</li><li>Dynamic routing (OSPF, EIGRP, BGP,…)</li><li>Floating routing</li><li>FHRP</li></ul></li>
        </ul>
        <h2 className='second-title'>Hands-on : Configure Routed network</h2>
        <h2 className="second-title">Day ( 5 )</h2>
        <h2 className="second-title">IP Services :</h2>
        <ul>
          <li className=''>QoS</li>
          <li className=''>NAT</li>
          <li className=''>DHCP, DNS</li>
          <li className=''>FTP/ TFTP</li>
          <li className=''>NTP</li>
          <li className=''>PHB</li>
          <li className=''>SNMP/ SYSLOG</li>
        </ul>
        <h2 className="second-title">Day ( 6 )</h2>
        <h2 className="second-title">NETWORK SECURITY FUNDAMENTALS</h2>
        <ul>
          <li className=''>Concepts</li>
          <li className=''>Device access security</li>
          <li className=''>Security at layer 2</li>
          <li className=''>Security at layer 3 (VPNs, IPSec)</li>
          <li className=''>Security at Layer 4 (ACLs)</li>
          <li className=''>Wireless network security</li>
          <li className=''>SNMP/ SYSLOG</li>
        </ul>
        <h2 className="second-title">Day ( 7 )</h2>
        <h2 className="second-title">Hands-on Labs : mini project</h2>
        <h2 className="second-title">Day ( 8 )</h2>
        <h2 className="second-title">AUTOMATION</h2>
        <ul>
          <li className=''>Controlled-Based architecture</li>
          <li className=''>SDN</li>
          <li className=''>DNA Platform</li>
          <li className=''>REST APIs</li>
          <li className=''>Ansible, Puppet, Chef</li>
          <li className=''>JSON</li>
        </ul>
        <h2 className="second-title">Day ( 9 )</h2>
        <h2 className="second-title">Hands-on Labs : Mini Projects</h2>
        <h2 className="second-title">Day ( 10 )</h2>
        <h2 className="second-title">CCNA Preparation test</h2>
          </div>
        </div>
        
        <div id="requirements" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Eligibility Requirements</h2>
			<ul>
				<li>Minimum of High school (SHS) Certificate to register</li>
			</ul>
           
        </div>
        <div id="admissions" className="group ">
          
          <a href="/apply-data-analytics" className="button full-width top-padding w-button c-buuton">APPLY NOW</a></div>
        </div>
      </div>
    </div>
  </div>
</div>
        </>
    );
  }
}

export default NetworkEngineeering;
